import React from 'react';
import { Button } from 'semantic-ui-react';
import StyleCheckResultList from '../../drogable/FindResult/StyleCheckResultList';

const CompleteView = ({ _WaveformView }) => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        width: '490px',
        height: '500px',
        overflow: 'scroll',
        padding: '1rem',
      }}
    >
      <h3>Send Complete message</h3>
      <div>
        <label>{_WaveformView.state.message}</label>
      </div>
      <StyleCheckResultList _WaveformView={_WaveformView} />
      <hr />

      <Button
        type='button'
        color='blue'
        onClick={async () => {
          await _WaveformView.setState({ isShowComplete: false });

          await _WaveformView.setState({ loading: true });

          await _WaveformView.send_Complete();

          await _WaveformView.setState({ loading: false });
        }}
      >
        Submit
      </Button>
      <Button
        type='button'
        basic={true}
        onClick={async () => {
          await _WaveformView.setState({ isShowComplete: false });
        }}
      >
        Cancel
      </Button>
    </div>
  );
};

export default CompleteView;



// WEBPACK FOOTER //
// ./src/components/popup/Complete/Complete_Popup.js